//@flow

import * as React from 'react';
import styled from 'styled-components';
import { css } from '@styled-system/css';

import { Box, Flex } from '@sonyged/proc-ui';
import { Button, ButtonIcon, Footer } from '@sonyged/ext-proc';

import { ArrowIcon, LossColor } from '../../../../common/components/ArrowIcon';
import Constants from '../../ice/fields/Constants';
import IceContext from '../../ice/fields/IceContext';

type DayCardProps = {
  active: boolean,
  past?: boolean,
  iceContexts: IceContext[],
  iceContextsIndex: number,
  onClick: number => void,
};

class DayCard extends React.Component<DayCardProps> {
  constructor(props: DayCardProps) {
    super(props);

    (this: any).handleClick = this.handleClick.bind(this);
  }

  handleClick(): void {
    if (this.props.active) {
      this.props.onClick(this.props.iceContextsIndex);
    }
  }

  render() {
    const iceContext = this.props.iceContexts[this.props.iceContextsIndex];
    const interest = iceContext.totalSales - iceContext.stockNum * Constants.DEFAULT_PRICE;

    let dim = this.props.past ? 'dim' : '';

    return (
      <li
        className={
          (this.props.past ? 'dim-white-bg-color' : 'white-bg-color') +
          (this.props.active ? ' proc-hover proc-button-se' : ' disabled')
        }
        onClick={this.handleClick}
      >
        <div className={'left secondary100-color ' + dim}>
          <div className={'secondary100-color day'}>
            {Constants.WEEKDAY_LABELS_ICE_ADV[iceContext.weekday]}
            {this.props.past ? 'のけっか' : ''}
          </div>

          {this.props.active && (
            <div className="weather">
              <span className={'weather-svg secondary100-fill-color'}>
                {Constants.getWetherSvg(iceContext.weather)}
              </span>
              <span>
                <span className={'proc-huge-font temperature'}>{iceContext.temperature}</span>
                <span className={'proc-medium-font temperature-postfix'}>度</span>
              </span>
            </div>
          )}
        </div>

        {this.props.active && iceContext.started && (
          <div className="right">
            <MoneyBox isLoss={interest < 0}>
              <span className="proc-large-font total">{Math.abs(interest)}</span>
              <span className="proc-small-font total-postfix"> 円 </span>
              <ArrowIcon forNum={interest} className="proc-medium-font" />
            </MoneyBox>
            <div className={dim}>
              <img className="image gray10-bg-color" src={Constants.getPlaceIcon(iceContext.place)} />
              <img className="image gray10-bg-color" src={Constants.getIceImage(iceContext.ice)} />
            </div>
          </div>
        )}
      </li>
    );
  }
}

const MoneyBox = styled(Box)(({ isLoss }) =>
  css({
    color: isLoss ? LossColor : 'gray100',
  })
);

type Props = {
  wagon: number,
  iceContexts: IceContext[],
  date: number,
  title: string,
  onPreviousClick?: () => void,
  onNextClick: () => void,
  onAnalysisClick: number => void,
};

class ResultContent extends React.Component<Props> {
  constructor(props: Props) {
    super(props);

    (this: any).handleCardClicked = this.handleCardClicked.bind(this);
  }

  handleCardClicked(index: number): void {
    const iceContext = this.props.iceContexts[index];
    if (iceContext.started) {
      this.props.onAnalysisClick(index);
    } else {
      this.props.onNextClick();
    }
  }

  render() {
    let total = this.props.iceContexts.reduce((acc, iceContext) => {
      if (iceContext.totalSales === 0) {
        return acc + iceContext.totalSales;
      } else {
        return acc + (iceContext.totalSales - iceContext.stockNum * Constants.DEFAULT_PRICE);
      }
    }, 0);
    return (
      <div className={'proc-ice-field-content result'}>
        <Box className={'proc-contents'} minHeight={0}>
          <div className={'proc-outer tertiary100-bg-color'}>
            <Flex className={'proc-inner'} flexDirection="column">
              <Box className="header" pb="16px !important">
                <div className="left" />
                <div className="center">
                  <img className="image" src={Constants.getStatusWagonIcon(this.props.wagon)} />
                </div>

                <div className="right total-price">
                  <div>
                    <div>
                      <span className="proc-small-font gray100-color">合計</span>
                    </div>
                    <MoneyBox isLoss={total < 0}>
                      <span className="total proc-huge-font">{Math.abs(total)}</span>
                      <span className="total-postfix proc-small-font">円</span>
                      <ArrowIcon forNum={total} className="proc-medium-font" />
                    </MoneyBox>
                  </div>
                </div>
              </Box>
              <ol className="result-list" style={{ paddingTop: 0, paddingBottom: 0, flex: 1, minHeight: 0 }}>
                <DayCard
                  past={this.props.date > 0}
                  active={this.props.date >= 0}
                  iceContexts={this.props.iceContexts}
                  iceContextsIndex={0}
                  onClick={this.handleCardClicked}
                />
                <DayCard
                  past={this.props.date > 1}
                  active={this.props.date >= 1}
                  iceContexts={this.props.iceContexts}
                  iceContextsIndex={1}
                  onClick={this.handleCardClicked}
                />
                <DayCard
                  past={this.props.date > 2}
                  active={this.props.date >= 2}
                  iceContexts={this.props.iceContexts}
                  iceContextsIndex={2}
                  onClick={this.handleCardClicked}
                />
                <DayCard
                  past={this.props.date > 3}
                  active={this.props.date >= 3}
                  iceContexts={this.props.iceContexts}
                  iceContextsIndex={3}
                  onClick={this.handleCardClicked}
                />
              </ol>
            </Flex>
          </div>
        </Box>
        <Footer.nav className="white-bg-color" navItem={this._renderPreviousButton()}>
          <Button.attention onClick={this.props.onNextClick}>つぎへ</Button.attention>
        </Footer.nav>
      </div>
    );
  }

  _renderPreviousButton() {
    if (!this.props.onPreviousClick) {
      return <span />;
    }
    return (
      <Button.normal onClick={this.props.onPreviousClick}>
        <ButtonIcon.back />
      </Button.normal>
    );
  }
}

export default ResultContent;
